export default __webpack_public_path__ + "static/banner_img-b644b75ec9ebcb64b7c8286b0b24fd12.webp";